import { create } from "zustand";
import { fetchSettings, getFullUser } from "@/app/providers/auth-provider/api";
import { storeSelectorGetter } from "@/lib/utils/store-selector-getter";
import { type IUserStore, USER_ROLES } from "./user.types";

export const useUserStore = create<IUserStore>()((set, get) => ({
  user: null,
  token: null,
  roles: [],
  devSettings: null,

  fetchDevSettings: async (signal) => {
    const current = get().devSettings;

    if (current) {
      return current;
    }

    const response = await fetchSettings(signal);
    set({ devSettings: response });

    return response;
  },
  updateDevSettings: (devSettings) => {
    set({ devSettings });
  },
  setUser: (user) => {
    set({ user, roles: user?.body?.rights?.map((item) => item.name) ?? [] });
  },
  setToken: (token) => {
    set({ token });
  },
  devAuthorize: (token) => {
    const devRoles = Object.values(USER_ROLES);
    set({
      token,
      roles: devRoles,
      user: {
        success: true,
        errorCode: 0,
        body: {
          rights: devRoles.map((name, index) => ({ id: -1 - index, name })),
          id: -1,
          profile: {
            id: -1,
            contacts: [],
            firstName: "dev",
            lastName: "dev",
            picture: "",
            postbackLinkIds: [],
            timeZone: "",
            userId: -1,
          },
          mail: "dev@mail.ru",
          refInfo: {
            wasInvited: false,
          },
          role: {
            id: -1,
            name: "dev",
          },
        },
      },
    });
  },
  authorize: async (token) => {
    set({ token, user: null, roles: [] });

    if (token) {
      const user = await getFullUser({ token });

      set({
        user,
        roles: user?.body?.rights?.map((item) => item.name) ?? [],
      });
    }
  },
}));

export const USER_STORE_SELECTORS = storeSelectorGetter<IUserStore>(useUserStore);
